import { useStreamData } from '@lib/hooks/useStreamData';
import { useTeamsData } from '@lib/hooks/useTeamsData';
import { useZoomData } from '@lib/hooks/useZoomData';
import { useTheme } from 'next-themes';

import useRedirect from '@zoom-app/hooks/useRedirect';

import Container from '@atoms/Container';
import UserGuide from '@components/UserGuide';

import DropdownDestination from './ZoomMenu';

const Header = (props) => {
  const { theme } = useTheme();

  const { showUserGuide, setShowUserGuide } = useStreamData(s => ({ showUserGuide: s.showUserGuide, setShowUserGuide: s.setShowUserGuide }));
  const user = useTeamsData((s) => s.user);
  const { isLoggedIn, logOutZoomApp } = useZoomData((s) => ({ isLoggedIn: s.isLoggedIn, logOutZoomApp: s.logOutZoomApp }));

  const { redirectToHome, getNextParam } = useRedirect();

  if (!isLoggedIn()) {
    return null;
  }

  return (
    <div className={`${isLoggedIn() ? 'flex' : 'hidden'} h-[60px] md:h-[57px] bg-white w-full z-50 border-b border-grey-200 items-center ${!props.shape && ''}`}>
      {showUserGuide && <UserGuide onCancel={() => setShowUserGuide(false)} />}
      <Container type='zoom' className={'max-w-[980px] px-4 md:px-0 py-4 mx-auto'}>
        <div className={isLoggedIn() ? 'flex w-full' : 'grid grid-cols-1 md:grid-cols-2'}>
          <div className="flex items-center justify-center md:justify-start">
            <a
              onClick={redirectToHome}
              className="block w-[162.75px] h-[15.92px]"
            >
              <img
                id="saLogoId"
                src={theme === 'light' ? '/images/Logo.svg' : '/images/Logo.svg'}
                className=" cursor-pointer w-[162.75px] h-[15.92px] md:block"
              />
            </a>
            {process.env.NEXT_PUBLIC_APP_ENV !== 'production' && <div className="font-bold ml-2">[{process.env.NEXT_PUBLIC_APP_ENV.slice(0, 3)}]</div>}
          </div>
          <div className={`flex items-center w-full ${isLoggedIn() ? ' justify-end ' : ' justify-center md:justify-end mt-4 md:mt-0 '}`}>
            {user && (
              <DropdownDestination logout={logOutZoomApp} page={props.page} nextParam={getNextParam()} />
            )}
          </div>
        </div>
      </Container >
    </div >
  );
};
export default Header;
